import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

const baseUrl = '/v2/artist/payouts';

/**
 *
 * @param {Object} payload {per_page}
 */
// eslint-disable-next-line import/prefer-default-export
export const listPayouts = async (params) => {
  params = params || {};
  const request = api.request('get', baseUrl, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });
  return request;
};

export const getPayoutBalance = async () => {
  const request = api.request('get', `${baseUrl}/balance`, {
    params: {
      ...api.getLocaleParams(),
    },
  });
  return request;
};

